export const modelsData = {
    "m-1000-rr": {
        name: "BMW M 1000 RR",
        subTitle: "RACING LIKE NO OTHER",
        description: "Для всех, кто не терпит ни миллисекунды зря. Аэродинамические характеристики супербайка, омологированного для гоночного спорта...",
        mainImage: "/assets/bagrounds_for_model_page/m-1000-RR_bg.jpg",

        // Картинка для блока описания (Скриншот 3)
        descriptionImage: "/assets/bagrounds_for_model_page/m-1000-RR_bg2.jpg",
        
        // Секция цветов (Скриншоты 1 и 2)
        colors: [
            { id: 1, name: "Light White / M Heritage", img: "/assets/moto_models/M1000RR/BMW_M1000RR_2.jpg", hex: "#ffffff" },
            { id: 2, name: "Black Storm Metallic", img: "/assets/moto_models/M1000RR/BMW_M1000RR_1.jpg", hex: "#222222" }
        ],

        // Фото с описанием (Скриншот 4)
        features: [
            { title: "Высококачественные фрезерованные детали M",img: "/assets/moto_models/M1000RR/details/detail_1.jpg" },
            { title: "Оптимизированные крылышки для максимального контроля", img: "/assets/moto_models/M1000RR/details/detail_2.jpg" },
            { title: "Выразительная передняя часть с ветрозащитным щитком", img: "/assets/moto_models/M1000RR/details/detail_3.jpg" },
            { title: "Slip-Slide Control", img: "/assets/moto_models/M1000RR/details/detail_4.jpg" },
            { title: "Деталь для эффективности: M Brake Ducts", img: "/assets/moto_models/M1000RR/details/detail_5.jpg" },
            { title: "Легкие карбоновые колеса M с полосками", img: "/assets/moto_models/M1000RR/details/detail_6.jpg" },
        ],

        // Технические характеристики (Скриншот 5)
        specs: {
            "Двигатель": [
                { label: "Номинальная мощность", value: "160 кВт (218 л.с.) при 14 500 об/мин" },
                { label: "Очистка отработавших газов", value: "Регулируемый 3-ходовой катализатор" },
                { label: "Модификация", value: "Четырехцилиндровый рядный двигатель с водяным/масляным охлаждением"},
                { label: "Диаметр и ход поршня", value: "80 мм х 49,7 мм" },
                { label: "Объем двигателя", value: "999 куб. см" },
                { label: "Макс. крутящий момент", value: "113 Нм при 11 100 об/мин" },
                { label: "Степень сжатия", value: "14,5 : 1" }
            ],
            "Ходовые качества / расход топлива": [
                { label: "Максимальная скорость", value: "314 км/ч" },
                { label: "Расход на 100 км согласно стандарту WMTC", value: "6,5 л" },
                { label: "Ускорение 0-100 км/ч", value: "3,1 с" }
            ]
        },

        // Комплектация (Скриншот 6)
        equipment: {
            standard: [
                "Быстродействующая ручка газа M",
                "Датчик угла поворота рулевого колеса с функциями Slip-Slide Control и Brake Slide Assist",
                "Аккумуляторная батарея M Lightweight",
                "Карбоновые колеса M",
                "Титановая система выпуска отработавших газов M",
                "BMW Motorrad ABS и ABS Pro",
                "Режимы движения Pro (Rain, Road, Dynamic, Race Pro 1-3)",
                "TFT-дисплей",
                "Круиз-контроль"
            ],
            special: [
                "Пакет M Competition с пакетом фрезерованных деталей M",
                "Пакет для пассажира на заднем сиденье",
                "Стартовые номера и набор спонсорских наклеек",
                "Система охранной сигнализации"
            ]
        }
    }
    // Сюда добавляются другие модели...
};